import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { debounce } from "lodash";
import {
  Avatar,
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Input,
  Modal,
  Row,
  Select,
  Switch,
  Table,
  Tooltip,
  message,
  Upload,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  FileImageOutlined,
  SearchOutlined,
  UploadOutlined,
  ClearOutlined, PlusOutlined, PrinterOutlined, CloseCircleFilled
} from "@ant-design/icons";
import { SetRoute } from "../scripts/action";
import { CheckPermission, PriceFormat, SearchFormat } from "../scripts/helpers";
import { Constants, Permissions } from "../scripts/settings";
import API from "../scripts/api";
import Resources from "../scripts/resources";
import PaginationInfo from "../components/PaginationInfo";
import PrintBarcodeForm from "../forms/PrintBarcodeForm";
import DeleteBarcode from "../forms/DeleteBarcode";
import PrintView from "../views/Print";
import moment from "moment-jalaali";
import DatePicker from "react-modern-calendar-datepicker";
import CirculationProductsBarcodesView from "../views/CirculationProductsBarcodesView";


class CirculationProducts extends Component {
  constructor() {
    super();

    this.state = {
      data: [],
      filter: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: Constants.pageSize,
        size: "small",
      },
      selected: {},
      barcodes: [],
      printView: false,
      visibleScanModal: false,
      visibleDeleteBarcodeModal: false,
    };

    this.formRef = React.createRef();
    this.uploadRef = React.createRef();
    this.scanModalRef = React.createRef();
    this.deleteBarcode = React.createRef();

    this.handleFilter = debounce(this.handleFilter, 1000);
  }

  fetch = (params = {}) => {
    const {
      filterEndDate,
      filterStartDate,
      q
    } = this.state;
    // params.q = "";
    params.q = q ? q : ""
    
    params.endDate = filterEndDate
        ? moment(
            `${filterEndDate.year}-${filterEndDate.month}-${filterEndDate.day}`,
            Constants.jDateFormat
        ).format(Constants.dateFormat)
        : null;
    params.startDate = filterStartDate
        ? moment(
            `${filterStartDate.year}-${filterStartDate.month}-${filterStartDate.day}`,
            Constants.jDateFormat
        ).format(Constants.dateFormat)
        : null;

    this.setState({ loading: true });

    API.circular_goods_products
      .list(params)
      .then(async (result) => {
          this.setState({
            loading: false,
            data: result.data.data,
             pagination: {
              ...this.state.pagination,
                  total: result.data.total,
                  current: result.data.current_page,
                  pageSize: result.data.per_page,
              }

          });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  static async sortByKey(array, key) {
    return array.sort(function(a, b) {
      var x = a[key]; var y = b[key];
      return ((x > y) ? 1 : ((x < y) ? -1 : 0));
    });
  }
  showModal = async (item = {}) => {

    this.setState({ visibleModal: true, selected: item });
    const {
      filterEndDate,
      filterStartDate,
      q
    } = this.state;
    const endDate = filterEndDate
        ? moment(
            `${filterEndDate.year}-${filterEndDate.month}-${filterEndDate.day}`,
            Constants.jDateFormat
        ).format(Constants.dateFormat)
        : null;
    const startDate = filterStartDate
        ? moment(
            `${filterStartDate.year}-${filterStartDate.month}-${filterStartDate.day}`,
            Constants.jDateFormat
        ).format(Constants.dateFormat)
        : null;
    setTimeout(() => {
      this.formRef.current.handleDidMount(item, startDate, endDate);
    }, 0);
  };


  hideModal = () => {
    this.setState({ visibleModal: false });

    setTimeout(() => {
      this.formRef.current.handleWillUnmount();
    }, 0);
  };




  handleFilter = (value, obj) => {
    const state = {};
    state[obj] = value;

    this.setState(state);

    setTimeout(() => {
      this.fetch({ page: 1});
    }, 0);
  };

 


  componentDidMount() {
    const { onSetRoute, routeName, parentName } = this.props;
    const { catId, subCatId } = this.props.match.params;

    onSetRoute({ openKey: parentName, selectedKey: routeName });


    setTimeout(() => {
      this.fetch({ page: 1 , q:this.state.filterSearch});
    }, 0);
  }



  getBarcodeType = (val) =>{
    if(val == "0"){
      return <span style={{color: "red"}}>{Resources.deleted}</span>
    }
    if(val == "1"){
      return <span style={{color: "green"}}>{Resources.scanned}</span>
    }
    if(val == "2"){
      return <span style={{color: "blue"}}>{Resources.created}</span>
    }
    if(val == "3"){
      return <span style={{color: "gray"}}>{Resources.returned}</span>
    }
  }

    handleTableChange = (pagination) => {
      this.fetch({
          page: pagination.current
      });
  };
  render() {
    const {
      data,
      loading,
      mainCats,
      pagination,
      submitting,
      visibleModal,
      printView,
      selected,
      visibleScanModal,
      visibleDeleteBarcodeModal,
      filterEndDate,
      filterStartDate,
      product

    } = this.state;
    const { permissions } = this.props;
    const { catId, subCatId } = this.props.match.params;

    const columns = [

       {
        title: Resources.title,
        dataIndex: "name",
        className: "col-ltr",

      },
      {
        title: Resources.barcode,
        dataIndex: "code",
        className: "col-center",
        // width: "130px",
      },

      {
        title: Resources.totalSale,
        dataIndex: "summary",
        className: "col-center",
        // width: "130px",
        render: (val, record) => PriceFormat(val.total_sales)
      },
      {
        title: Resources.remain,
        dataIndex: "summary",
        className: "col-center",
        // width: "130px",
        render: (val, record) => PriceFormat(val.barcode_count)
      },
 
      {
              title: Resources.action,
              dataIndex: "id",
              className: "col-center",
              width: "120px",
              render: (val, record) => (
                <Fragment>
                    <Tooltip title={Resources.view}>
                      <Button
                        type="link"
                        icon={<EyeOutlined />}
                        onClick={() => this.showModal(record)}
                      />
                    </Tooltip>
                   
                </Fragment>
              ),
            }
    
  


    ];

    const DatePickerInput = ({ ref }, date, placeholder) => (
        <Input
            value={date ? `${date.year}-${date.month}-${date.day}` : date}
            placeholder={placeholder}
            ref={ref}
            readOnly
        />
    );


    return (
      <Fragment>
        <PrintView
            data={selected}
            visible={printView}
            onClose={this.hideView}
        />
        <Breadcrumb>
          <Breadcrumb.Item>{Resources.circulationProducts}</Breadcrumb.Item>
          
        </Breadcrumb>
        <div className="ant-content">
          <Row gutter={24}>
            <Col xs={24} md={12}>
              <Tooltip title={Resources.searchHintOffer}>
                <Input
                  type="text"
                  prefix={<SearchOutlined />}
                  placeholder={Resources.search}
                  onChange={({ target: { value } }) =>
                    this.handleFilter(value, "q")
                  }
                  allowClear
                />
              </Tooltip>
            </Col>
            <Col xs={24} md={6}>
              <DatePicker
                  locale="fa"
                  value={filterStartDate}
                  onChange={(value) =>
                      this.handleFilter(value, "filterStartDate")
                  }
                  renderInput={(ref) =>
                      DatePickerInput(ref, filterStartDate, Resources.fromDate)
                  }
                  shouldHighlightWeekends
              />
              {filterStartDate && (
                  <CloseCircleFilled
                      style={{zIndex: "1000000000"}}

                      className="ant-input-clear-icon ant-input-clear-icon-external"
                      onClick={() => this.handleFilter(null, "filterStartDate")}
                  />
              )}
            </Col>
            <Col xs={24} md={6}>
              <DatePicker
                  locale="fa"
                  value={filterEndDate}
                  onChange={(value) => this.handleFilter(value, "filterEndDate")}
                  renderInput={(ref) =>
                      DatePickerInput(ref, filterEndDate, Resources.toDate)
                  }
                  shouldHighlightWeekends
              />
              {filterEndDate && (
                  <CloseCircleFilled
                      style={{zIndex: "1000000000"}}
                      className="ant-input-clear-icon ant-input-clear-icon-external"
                      onClick={() => this.handleFilter(null, "filterEndDate")}
                  />
              )}
            </Col>

            {/* <Col xs={24} md={4}>
              <Button type="primary" icon={<PlusOutlined />} onClick={() => this.showModal()} block>{Resources.add}</Button>
            </Col> */}
          </Row>
        </div>
        <div className="ant-content">
         
          <Table
            columns={columns}
            dataSource={data}
            loading={loading}
            onChange={this.handleTableChange}
            pagination={pagination}
            size="small"
            rowKey="id"
            scroll={{ x: 936 }}
          /> 
         
        </div>
        <CirculationProductsBarcodesView
          ref={this.formRef}
          onCancel={this.hideModal}
          onSubmit={this.hideModal}
          submitting={submitting}
          visible={visibleModal}
        />
       
       
      </Fragment>
    );
  }
}

export default connect(
  (state) => {
    return {
      permissions: {
        action: CheckPermission(state.app.user, Permissions.product_option),
      },
    };
  },
  (dispatch) => {
    return {
      onSetRoute: (data) => dispatch(SetRoute(data)),
    };
  }
)(CirculationProducts);
